import enviroment from "../enviroments";

// Caso seja o ambiente de pre-prod a arquitetura muda ( somente o prefixo ), no contexto de leads.
const leadsWebEnviroment =
  enviroment.URL_ADMIN === "https://sellit-app-web-pre-prod.azurewebsites.net"
    ? "leads-pre-prod"
    : "leads";

export default leadsWebEnviroment;
